// In case of questions please check https://www.w3.org/TR/uievents-key/#keys-whitespace
export const EVENT_KEY_RETURN = 'Enter';
export const EVENT_KEY_ESC = 'Escape';
export const EVENT_KEY_SPACE = ' ';
export const EVENT_KEY_TAB = 'Tab';
export const EVENT_KEY_UP = 'ArrowUp';
export const EVENT_KEY_DOWN = 'ArrowDown';
export const EVENT_KEY_LEFT = 'ArrowLeft';
export const EVENT_KEY_RIGHT = 'ArrowRight';
export const isActivationKey = key => {
  return key === EVENT_KEY_RETURN || key === EVENT_KEY_SPACE;
};
//# sourceMappingURL=event-key-names.js.map